import { Button, Menu, Tooltip } from "@mantine/core";
import React from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, UncontrolledTooltip } from "reactstrap";

interface ExcelExportDropdownProps {
  excelExportVisibleColumns: any;
  exportExcelAllColumns: any;
  mantineStyle?: boolean; // when true use Mantine version
}

const ExcelExportDropdown: React.FC<ExcelExportDropdownProps> = ({
  excelExportVisibleColumns,
  exportExcelAllColumns,
  mantineStyle = false,
}) => {
  if (!mantineStyle) {
    // Original Reactstrap version (unchanged)
    return (
      <>
        <UncontrolledTooltip placement="top" target="excel">
          Eksporter til Excel
        </UncontrolledTooltip>
        <UncontrolledDropdown>
          <DropdownToggle color="mc-blue" caret id="excel">
            <i className="fa fa-file-excel-o fa-fw" />
          </DropdownToggle>
          <DropdownMenu className="moveLeft">
            <DropdownItem onClick={() => exportExcelAllColumns()}>Eksporter alle kolonner</DropdownItem>
            <DropdownItem onClick={() => excelExportVisibleColumns()}>Eksporter utvalgte kolonner</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </>
    );
  }

  // Mantine alternative
  return (
    <Menu shadow="md" width={240} position="bottom-end" withinPortal>
      <Menu.Target>
        <Tooltip label="Eksporter til Excel" withArrow offset={2} openDelay={200}>
          <Button variant="light" color="mc-primary" px="sm" size="sm" aria-label="Eksporter til Excel">
            <i className="fa fa-file-excel-o fa-fw" />
          </Button>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={() => exportExcelAllColumns()} leftSection={<i className="fa fa-table fa-fw" />}>
          Eksporter alle kolonner
        </Menu.Item>
        <Menu.Item onClick={() => excelExportVisibleColumns()} leftSection={<i className="fa fa-columns fa-fw" />}>
          Eksporter utvalgte kolonner
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default ExcelExportDropdown;
